// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ═══════════════════════════════════════════════════════════
   DonationsPage — member giving history
═══════════════════════════════════════════════════════════ */

.dn__loading { display: flex; justify-content: center; padding: 3rem; }
.dn__spinner {
  width: 1.75rem; height: 1.75rem;
  border: 2px solid rgba(184,92,56,0.2);
  border-top-color: var(--portal-rust, #b85c38);
  border-radius: 50%;
  animation: dn-spin 0.7s linear infinite;
}
@keyframes dn-spin { to { transform: rotate(360deg); } }

/* ── Totals ── */
.dn__totals {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 0.85rem;
  margin-bottom: 1.25rem;
}
.dn__total-card {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  padding: 1.15rem 1.25rem;
}
.dn__total-icon {
  width: 2.75rem; height: 2.75rem;
  border-radius: 50%;
  background: rgba(184,92,56,0.12);
  color: var(--portal-rust, #b85c38);
  display: flex; align-items: center; justify-content: center;
  font-size: 1.2rem;
  flex-shrink: 0;
}
.dn__total-icon--muted {
  background: var(--portal-surface, #faf7f2);
  color: var(--portal-muted, #6b6258);
}
.dn__total-value {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--portal-text, #1b1b1b);
  margin: 0;
  line-height: 1.1;
}
.dn__total-label {
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--portal-muted, #6b6258);
  margin: 0.2rem 0 0;
}

/* ── CTA ── */
.dn__cta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.25rem;
  flex-wrap: wrap;
  padding: 1.25rem;
  margin-bottom: 1.25rem;
  background: linear-gradient(135deg, #1e2a1e 0%, #2d3e2d 100%);
  border: none;
}
.dn__cta-body { flex: 1 1; min-width: 220px; }
.dn__cta-title {
  font-size: 1rem;
  font-weight: 700;
  color: #fff;
  margin: 0 0 0.3rem;
}
.dn__cta-sub {
  font-size: 0.83rem;
  color: rgba(255,255,255,0.75);
  margin: 0;
  line-height: 1.6;
  max-width: 46ch;
}
.dn__cta-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  background: var(--portal-rust, #b85c38);
  color: #fff;
  text-decoration: none;
  font-size: 0.88rem;
  font-weight: 700;
  padding: 0.7rem 1.35rem;
  border-radius: 8px;
  transition: filter 0.15s;
  white-space: nowrap;
  flex-shrink: 0;
}
.dn__cta-btn:hover { filter: brightness(1.08); }
.dn__cta-btn-ext { font-size: 0.75rem; opacity: 0.75; }

/* ── History section ── */
.dn__section { padding: 1.5rem; }
.dn__section-head {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.35rem;
}
.dn__section-icon { font-size: 1.1rem; color: var(--portal-rust, #b85c38); }
.dn__section-count {
  margin-left: auto;
  font-size: 0.72rem;
  font-weight: 700;
  background: var(--portal-surface, #faf7f2);
  color: var(--portal-muted, #6b6258);
  padding: 0.2rem 0.6rem;
  border-radius: 99px;
  white-space: nowrap;
}
.dn__section-sub {
  font-size: 0.81rem;
  color: var(--portal-muted, #6b6258);
  margin: 0 0 1.1rem;
  line-height: 1.55;
}

.dn__list { display: flex; flex-direction: column; }
.dn__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.85rem 0;
  border-bottom: 1px solid var(--portal-border, #e8e3da);
}
.dn__row:last-child { border-bottom: none; }
.dn__row-main { min-width: 0; }
.dn__row-amount {
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--portal-text, #1b1b1b);
  margin: 0;
}
.dn__row-meta {
  font-size: 0.76rem;
  color: var(--portal-muted, #6b6258);
  margin: 0.15rem 0 0;
}
.dn__receipt { font-variant-numeric: tabular-nums; }
.dn__row-date {
  font-size: 0.79rem;
  color: var(--portal-muted, #6b6258);
  margin: 0;
  white-space: nowrap;
  flex-shrink: 0;
}

/* ── Empty ── */
.dn__empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 2.75rem 1.5rem;
}
.dn__empty-icon { font-size: 2rem; color: var(--portal-border, #e8e3da); margin-bottom: 0.5rem; }
.dn__empty-title {
  font-size: 1rem;
  font-weight: 700;
  color: var(--portal-text, #1b1b1b);
  margin: 0 0 0.3rem;
}
.dn__empty-sub {
  font-size: 0.84rem;
  color: var(--portal-muted, #6b6258);
  margin: 0;
  max-width: 40ch;
  line-height: 1.6;
}

@media (max-width: 640px) {
  .dn__cta { flex-direction: column; align-items: stretch; }
  .dn__cta-btn { justify-content: center; }
  .dn__row { flex-direction: column; align-items: flex-start; gap: 0.25rem; }
}
`, "",{"version":3,"sources":["webpack://./src/portal/DonationsPage.css"],"names":[],"mappings":"AAAA;;6DAE6D;;AAE7D,eAAe,aAAa,EAAE,uBAAuB,EAAE,aAAa,EAAE;AACtE;EACE,cAAc,EAAE,eAAe;EAC/B,qCAAqC;EACrC,6CAA6C;EAC7C,kBAAkB;EAClB,uCAAuC;AACzC;AACA,qBAAqB,KAAK,yBAAyB,EAAE,EAAE;;AAEvD,iBAAiB;AACjB;EACE,aAAa;EACb,2DAA2D;EAC3D,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;AAC1B;AACA;EACE,cAAc,EAAE,eAAe;EAC/B,kBAAkB;EAClB,gCAAgC;EAChC,kCAAkC;EAClC,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,0CAA0C;EAC1C,mCAAmC;AACrC;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;EAClC,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,6DAA6D;EAC7D,YAAY;AACd;AACA,gBAAgB,SAAO,EAAE,gBAAgB,EAAE;AAC3C;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,uCAAuC;EACvC,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,cAAc;AAChB;AACA,qBAAqB,wBAAwB,EAAE;AAC/C,mBAAmB,kBAAkB,EAAE,aAAa,EAAE;;AAEtD,0BAA0B;AAC1B,eAAe,eAAe,EAAE;AAChC;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;AACxB;AACA,oBAAoB,iBAAiB,EAAE,kCAAkC,EAAE;AAC3E;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;EAC1C,mCAAmC;EACnC,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,YAAY,aAAa,EAAE,sBAAsB,EAAE;AACnD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,sDAAsD;AACxD;AACA,sBAAsB,mBAAmB,EAAE;AAC3C,gBAAgB,YAAY,EAAE;AAC9B;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,mBAAmB;AACrB;AACA,eAAe,kCAAkC,EAAE;AACnD;EACE,kBAAkB;EAClB,mCAAmC;EACnC,SAAS;EACT,mBAAmB;EACnB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;AACzB;AACA,kBAAkB,eAAe,EAAE,oCAAoC,EAAE,qBAAqB,EAAE;AAChG;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW,sBAAsB,EAAE,oBAAoB,EAAE;EACzD,eAAe,uBAAuB,EAAE;EACxC,WAAW,sBAAsB,EAAE,uBAAuB,EAAE,YAAY,EAAE;AAC5E","sourcesContent":["/* ═══════════════════════════════════════════════════════════\n   DonationsPage — member giving history\n═══════════════════════════════════════════════════════════ */\n\n.dn__loading { display: flex; justify-content: center; padding: 3rem; }\n.dn__spinner {\n  width: 1.75rem; height: 1.75rem;\n  border: 2px solid rgba(184,92,56,0.2);\n  border-top-color: var(--portal-rust, #b85c38);\n  border-radius: 50%;\n  animation: dn-spin 0.7s linear infinite;\n}\n@keyframes dn-spin { to { transform: rotate(360deg); } }\n\n/* ── Totals ── */\n.dn__totals {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 0.85rem;\n  margin-bottom: 1.25rem;\n}\n.dn__total-card {\n  display: flex;\n  align-items: center;\n  gap: 0.85rem;\n  padding: 1.15rem 1.25rem;\n}\n.dn__total-icon {\n  width: 2.75rem; height: 2.75rem;\n  border-radius: 50%;\n  background: rgba(184,92,56,0.12);\n  color: var(--portal-rust, #b85c38);\n  display: flex; align-items: center; justify-content: center;\n  font-size: 1.2rem;\n  flex-shrink: 0;\n}\n.dn__total-icon--muted {\n  background: var(--portal-surface, #faf7f2);\n  color: var(--portal-muted, #6b6258);\n}\n.dn__total-value {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: var(--portal-text, #1b1b1b);\n  margin: 0;\n  line-height: 1.1;\n}\n.dn__total-label {\n  font-size: 0.75rem;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--portal-muted, #6b6258);\n  margin: 0.2rem 0 0;\n}\n\n/* ── CTA ── */\n.dn__cta {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1.25rem;\n  flex-wrap: wrap;\n  padding: 1.25rem;\n  margin-bottom: 1.25rem;\n  background: linear-gradient(135deg, #1e2a1e 0%, #2d3e2d 100%);\n  border: none;\n}\n.dn__cta-body { flex: 1; min-width: 220px; }\n.dn__cta-title {\n  font-size: 1rem;\n  font-weight: 700;\n  color: #fff;\n  margin: 0 0 0.3rem;\n}\n.dn__cta-sub {\n  font-size: 0.83rem;\n  color: rgba(255,255,255,0.75);\n  margin: 0;\n  line-height: 1.6;\n  max-width: 46ch;\n}\n.dn__cta-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n  background: var(--portal-rust, #b85c38);\n  color: #fff;\n  text-decoration: none;\n  font-size: 0.88rem;\n  font-weight: 700;\n  padding: 0.7rem 1.35rem;\n  border-radius: 8px;\n  transition: filter 0.15s;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n.dn__cta-btn:hover { filter: brightness(1.08); }\n.dn__cta-btn-ext { font-size: 0.75rem; opacity: 0.75; }\n\n/* ── History section ── */\n.dn__section { padding: 1.5rem; }\n.dn__section-head {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-bottom: 0.35rem;\n}\n.dn__section-icon { font-size: 1.1rem; color: var(--portal-rust, #b85c38); }\n.dn__section-count {\n  margin-left: auto;\n  font-size: 0.72rem;\n  font-weight: 700;\n  background: var(--portal-surface, #faf7f2);\n  color: var(--portal-muted, #6b6258);\n  padding: 0.2rem 0.6rem;\n  border-radius: 99px;\n  white-space: nowrap;\n}\n.dn__section-sub {\n  font-size: 0.81rem;\n  color: var(--portal-muted, #6b6258);\n  margin: 0 0 1.1rem;\n  line-height: 1.55;\n}\n\n.dn__list { display: flex; flex-direction: column; }\n.dn__row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 0.85rem 0;\n  border-bottom: 1px solid var(--portal-border, #e8e3da);\n}\n.dn__row:last-child { border-bottom: none; }\n.dn__row-main { min-width: 0; }\n.dn__row-amount {\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: var(--portal-text, #1b1b1b);\n  margin: 0;\n}\n.dn__row-meta {\n  font-size: 0.76rem;\n  color: var(--portal-muted, #6b6258);\n  margin: 0.15rem 0 0;\n}\n.dn__receipt { font-variant-numeric: tabular-nums; }\n.dn__row-date {\n  font-size: 0.79rem;\n  color: var(--portal-muted, #6b6258);\n  margin: 0;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n/* ── Empty ── */\n.dn__empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  padding: 2.75rem 1.5rem;\n}\n.dn__empty-icon { font-size: 2rem; color: var(--portal-border, #e8e3da); margin-bottom: 0.5rem; }\n.dn__empty-title {\n  font-size: 1rem;\n  font-weight: 700;\n  color: var(--portal-text, #1b1b1b);\n  margin: 0 0 0.3rem;\n}\n.dn__empty-sub {\n  font-size: 0.84rem;\n  color: var(--portal-muted, #6b6258);\n  margin: 0;\n  max-width: 40ch;\n  line-height: 1.6;\n}\n\n@media (max-width: 640px) {\n  .dn__cta { flex-direction: column; align-items: stretch; }\n  .dn__cta-btn { justify-content: center; }\n  .dn__row { flex-direction: column; align-items: flex-start; gap: 0.25rem; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
